import gql from 'graphql-tag';

export const LINK_TRANSACTION_TO_WORKFLOW = gql`
    mutation linkTransactionToWorkflow(
        $input: LinkTransactionToWorkflowInput!
    ) {
        linkTransactionToWorkflow(input: $input) {
            id
        }
    }
`;
